// @flow
import BuildingsData from './BuildingsData';
import BuildingsView from './BuildingsView';
import type { Buildings, Building } from './BuildingsTypes';

export default BuildingsData;
export { BuildingsView };
export type { Buildings, Building };
